import styled from "styled-components";
import theme from "../../theme/theme";
import { ReactComponent as PlusIcon } from "../../assets/plus-icon.svg";
import { useDispatch, useSelector } from "react-redux";
import { updateSavingsPlan } from "../../redux/actions";

const Wrapper = styled.button`
  position: relative;
  display: flex;
  flex-direction: column;
  border: none;
  border: 2px solid transparent;
  background-color: ${theme.colors.white};
  border-left-width: 10px;
  width: 100%;
  box-sizing: border-box;
  padding: 20px;

  &.invested {
    border-color: ${theme.colors.primary};
    background-color: #fafeff;
  }

  &:hover:not(:disabled) {
    background-color: ${theme.colors.grayBg};
  }

  .selected {
    font-size: 12px;
    font-weight: 800;
    margin-bottom: 10px;
    letter-spacing: 0px;
    color: ${theme.colors.primaryStrong};
  }

  .arrowRight {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translate(-20px, -50%) rotate(-45deg);
    border: solid black;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 3px;
    border-color: ${theme.colors.primaryStrong};
  }

  .strategyName {
    max-width: 250px;
    text-align: left;
    font-size: 1.2em;
    font-weight: 800;
    line-height: 1.25;
    color: ${theme.colors.black1};
  }

  .blendedModels {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    color: #3a3a3d;
  }

  .blendedModel svg {
    width: 11px;
    height: 11px;
    margin-right: 10px;
  }

  .learnMore {
    margin-top: 20px;
    color: ${theme.colors.primaryStrong};
    font-size: 1em;
    line-height: 1.25;
  }
`;

const StrategyItem = ({ strategy }) => {
  const { name, isSelected, blendedModels, managers } = strategy;
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const updateDashboardData = (strategyId) => {
    const updateData = {
      savingsPlanId: user?.savingsPlanId,
      changedParam: "none",
      settingsData: user?.dashboardData.settings,
      strategies: [strategyId],
    };

    dispatch(updateSavingsPlan({ data: updateData }));
  };

  const handleClick = (e) => {
    e.stopPropagation();
    updateDashboardData(strategy.id);
  };

  return (
    <Wrapper
      className={`${isSelected ? "invested" : ""}`}
      onClick={handleClick}
      disabled={isSelected}
    >
      {isSelected ? <span className="selected">SELECTED</span> : null}
      <span className="strategyName">{name}</span>
      <div className="blendedModels">
        {managers.map((model, i) => (
          <span className="blendedModel" key={i}>
            <PlusIcon />
            {model.name}
          </span>
        ))}
      </div>
      <a
        className="learnMore"
        href="https://tactivewealth.com/financial-investment-strategies/"
        target="_blank"
        rel="noreferrer"
      >
        Learn more
      </a>
    </Wrapper>
  );
};

export default StrategyItem;
